var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.containerStyle),attrs:{"id":"app-container"}},[_c('div',{style:(_vm.contentStyle),attrs:{"id":"app-content"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }